let count = 0;
module.exports = function uuid() {
  return 'react-tinymce-' + count++;
};



/** WEBPACK FOOTER **
 ** ./lib/helpers/uuid.js
 **/